export default __webpack_public_path__ + "static/Environments-c00178d4f677a03a443c7066d66d581f.webp";